<div class="main-modal-bg">
    <div class="inner-frame-bg inner-frame-mobile">
    <div class="preview-container-mobile" >
      <figure class="figure-phone">
        <svg class="phone-shell-svg" viewBox="0 0 100% 100%" aria-hidden="true" focusable="false">
          <defs>
            <linearGradient id="phoneSideGlow" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stop-color="#dbdbdb"></stop>
              <stop offset="7%" stop-color="#4d6dc4"></stop>
              <stop offset="32%" stop-color="#aeafb0"></stop>
              <stop offset="70%" stop-color="#aeafb0"></stop>
              <stop offset="90%" stop-color="#142452"></stop>
              <stop offset="100%" stop-color="#142452"></stop>
            </linearGradient>
            <linearGradient id="sideButtonGlow" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#aeafb0"></stop>
              <stop offset="40%" stop-color="#3d4558"></stop>
              <stop offset="100%" stop-color="#313233"></stop>
            </linearGradient>
            <linearGradient id="sideButtonLeftGlow" x1="100%" y1="0%" x2="0%" y2="0%">
              <stop offset="0%" stop-color="#aeafb0"></stop>
              <stop offset="40%" stop-color="#3d4558"></stop>
              <stop offset="100%" stop-color="#313233"></stop>
            </linearGradient>
            <linearGradient id="bezelHighlight" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stop-color="#4f5668" stop-opacity="0.45"></stop>
              <stop offset="70%" stop-color="#0e1118" stop-opacity="0"></stop>
              <stop offset="100%" stop-color="#0e1118" stop-opacity="0.3"></stop>
            </linearGradient>
          </defs>
          <rect class="device-outer" x="3" y="0" width="408" height="848" rx="64"></rect>
          <rect class="device-outer-highlight" x="6" y="4" width="400" height="840" rx="60"></rect>
          <rect class="device-screen-border" x="14" y="14" width="376" height="812" rx="48"></rect>
          <rect class="device-screen-border-gloss" x="14" y="14" width="376" height="812" rx="48"></rect>
          <rect class="device-notch" x="50%" y="34" width="53.34" height="26.67" rx="12" transform="translate(-26.67 0)"></rect>
          <circle class="camera-dot" cx="50%" cy="47" r="7" transform="translate(15 0)"></circle>
          <rect class="side-button side-button-top" x="0" y="156" width="4" height="34" rx="2"></rect>
          <rect class="side-button side-button-mid" x="0" y="224" width="4" height="76" rx="2"></rect>
          <rect class="side-button side-button-low" x="0" y="318" width="4" height="76" rx="2"></rect>
          <rect class="side-button side-button-right" x="99%" y="242" width="4" height="108" rx="2"></rect>
        </svg>
        <div class="mobile-content">
          <iframe [src]="iframeSrc" width="380px" height="930px" allowfullscreen="" loading="lazy" class="mobile-iframe" id="mobile-iframe" ></iframe>
        </div>
        <div class="notch-overlay" aria-hidden="true">
          <span class="notch-camera-dot"></span>
        </div>
      </figure>
    </div>
  </div>
</div>
